export function pageWindow(
  currentPage: number,
  totalPages: number,
  maxSlots: number,
): Array<number | "ellipsis"> {
  if (totalPages <= maxSlots) {
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }

  const middleSlots = Math.max(1, maxSlots - 2);
  let start = Math.max(2, currentPage - Math.floor(middleSlots / 2));
  let end = Math.min(totalPages - 1, start + middleSlots - 1);
  start = Math.max(2, end - middleSlots + 1);

  const pages: Array<number | "ellipsis"> = [1];
  if (start > 2) pages.push("ellipsis");
  for (let page = start; page <= end; page++) pages.push(page);
  if (end < totalPages - 1) pages.push("ellipsis");
  pages.push(totalPages);
  return pages;
}
